
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'base-button',
  props: {
    color: {
      type: String as PropType<'primary' | 'warning' | 'error'>,
      default: 'primary',
    },
    disabled: { type: Boolean, default: false },
  },
  computed: {},
})
